import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import BodyHeader from "../../../components/customComp/BodyHeader";
import PatientBody from "./PatientBody";
import BodySeparator from "../../../components/customComp/BodySeparator";
const PatientComp = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [patientData, setPatientData] = useState({});
  const [patientCases, setPatientCases] = useState([]);

  

  const { patientID } = useParams();
  // Fetch patient data by patientID
  useEffect(() => {
    const fetchPatientData = async () => {
      setIsLoading(true);
      try {
        const fetchedPatientData = await getAllCasesByPatient(patientID);
        setPatientData(fetchedPatientData);
        setPatientCases(fetchedPatientData.exams || []);
      } catch (error) {
        console.error("Error fetching patient data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchPatientData();
  }, [patientID]);

  const getAllCasesByPatient = async (patientID) => {
    return await props.restApi.getAllCasesByPatient(patientID);
  };

  const hasPending =
    Array.isArray(patientCases) &&
    patientCases.some((e) => e.status === "pending");

  const getAge = (birthYear) => {
    const y = parseInt(birthYear, 10);
    if (isNaN(y)) return "—";
    return new Date().getFullYear() - y;
  };

  return (
    <div
      className={
        "w-full px-[15%] pt-[10vh] h-full max-h-full overflow-hidden box-border "
      }>
      <div className="flex items-end gap-10">
        {/* Left: name + status (your existing design) */}
        <div className="text-white flex flex-col gap-2">
          <BodyHeader
            title={patientData.name || "Loading..."}
            includeButton={false}
          />
          <div className="text-[#C1C1C1] text-[16px] flex items-center gap-2">
            <span
              className={`inline-block w-[10px] h-[10px] rounded-full ${
                hasPending ? "bg-yellow-400" : "bg-green-500"
              }`}
            />
            {hasPending ? "Waiting for analysis" : "Complete"}
          </div>
        </div>

        <div className="flex gap-16">
          <div className="flex flex-col items-start">
            <div className="text-white text-[14px]">Patient ID</div>
            <div className="text-[#C1C1C1] text-[16px] mt-1">
              {patientData.patientID || "—"}
            </div>
          </div>
          <div className="flex flex-col items-start">
            <div className="text-white text-[14px]">Age</div>
            <div className="text-[#C1C1C1] text-[16px] mt-1">
              {getAge(patientData.birthYear)}
            </div>
          </div>
        </div>
      </div>

      <BodySeparator className="mt-[30px] mb-[30px]" />
      <div className=" h-full max-h-full overflow-clip">
        <PatientBody patientCases={patientCases} addTab={props.addTab} />
      </div>
    </div>
  );
};

export default PatientComp;
